import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Container, Icon } from "semantic-ui-react";

class AssignContractorEvent extends React.Component {
  static propTypes = {
    date: PropTypes.string,
    user: PropTypes.string
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { date, user, name } = this.props;

    return (
      <div data-component="timelineItem" data-event="contractor_assigned">
        <div className="bullet-pointer">
          <Icon color="grey" size="large" circular name="shipping" />
          <Icon color="green" name="plus" className="corner" />
        </div>
        <Container data-component="logDetails">
          <time>{date}</time>{" "}
          <FormattedMessage
            id="activity.timeline.event.assignContractor"
            defaultMessage="activity.timeline.event.assignContractor"
            values={{ name }}
          />
          <div className="user">{user}</div>
        </Container>
      </div>
    );
  }
}

export default AssignContractorEvent;
